// extracted by mini-css-extract-plugin
export default {"location":"icon-row_location__1UOPO typography_bodyFont__1UNdB","pinIcon":"icon-row_pinIcon__2QNUB"};